import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 자동화 설정 > 변수 설정 > 변수 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   */
  getVariableList(params) {
    return axios.post(`${baseUrl}/settings/ams/variable/get-variable-list.do`, params);
  },
  /**
   * 자동화 설정 > 변수 설정 >  변수 추가 또는 수정
   * @author jeee12
   * @param  {[type]} params [description]
   */
  insertVariable(params) {
    return axios.post(`${baseUrl}/settings/ams/variable/insert-variable.do`, params);
  },
  /**
   * 자동화 설정 > 변수 설정 >  변수 삭제
   * @author jeee12
   * @param  {[type]} params [description]
   */
  deleteVariableList(params) {
    return axios.post(`${baseUrl}/settings/ams/variable/delete-variable-list.do`, params);
  },
  /**
   * 자동화 설정 > 태스크 설정 > 태스크 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   */
  getTaskList(params) {
    return axios.post(`${baseUrl}/settings/ams/task/get-task-list.do`, params);
  },
  /**
   * 자동화 설정 > 태스크 설정 > 태스크 구분 및 변수 목록 조회
   * @author jeee12
   * @return {[type]} [description]
   */
  getVarDefGrpList() {
    return axios.get(`${baseUrl}/settings/ams/task/get-var-def-grp-list.do`);
  },
  /**
   * 자동화 설정 > 태스크 설정 > 태스크 아이디, 이름 중복체크
   * @author jeee12
   * @param  {[type]} params [description]
   */
  checkTaskValidation(params) {
    return axios.post(`${baseUrl}/settings/ams/task/check-task-validation.do`, params);
  },
  /**
   * 자동화 설정 > 태스크 설정 > 태스크 추가 또는 수정
   * @author jeee12
   * @param  {[type]} params [description]
   */
  insertTask(params) {
    return axios.post(`${baseUrl}/settings/ams/task/insert-task.do`, params);
  },
  /**
   * 자동화 설정 > 태스크 설정 > 태스크 목록 삭제
   * @author jeee12
   * @param  {[type]} params [description]
   */
  deleteTaskList(params) {
    return axios.post(`${baseUrl}/settings/ams/task/delete-task-list.do`, params);
  },
  /**
   * 자동화 설정 > 태스크 설정 > 태스크에 따른 태스크 정의 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   */
  getTaskDefList(params) {
    return axios.post(`${baseUrl}/settings/ams/task/get-task-def-list.do`, params);
  },
  /**
   * 자동화 설정 > 태스크 설정 > 태스크에 따른 태스크 변수 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   */
  getTaskVarList(params) {
    return axios.post(`${baseUrl}/settings/ams/task/get-task-var-list.do`, params);
  },
  /**
   * 자동화 설정 > 태스크 설정 > 태스크 정의 os, 공급자, 버전, 아키텍처 목록 조회
   * @author jeee12
   */
  getNodetypeList() {
    return axios.get(`${baseUrl}/settings/ams/task/get-nodetype-list.do`);
  },
  /**
   * 자동화 설정 > 태스크 설정 > 태스크 정의 추가 또는 수정
   * @author jeee12
   * @param  {[type]} params [description]
   */
  insertTaskDef(params) {
    return axios.post(`${baseUrl}/settings/ams/task/insert-task-def.do`, params);
  },
  /**
   * 자동화 설정 > 태스크 설정 > 태스크 정의 목록 삭제
   * @author jeee12
   * @param  {[type]} params [description]
   */
  deleteTaskDefList(params) {
    return axios.post(`${baseUrl}/settings/ams/task/delete-task-def-list.do`, params);
  },
  /**
   * 자동화 설정 > 태스크 설정 > 태스크 정의 변수 중복체크
   * @author jeee12
   * @param  {[type]} params [description]
   */
  checkTaskVariableIdValidation(params) {
    return axios.post(`${baseUrl}/settings/ams/task/check-task-variable-id-validation.do`, params);
  },
  /**
   * 자동화 설정 > 태스크 설정 > 태스크 변수 수정
   * @author jeee12
   * @param  {[type]} params [description]
   */
  updateTaskVariableList(params) {
    return axios.post(`${baseUrl}/settings/ams/task/update-task-variable-list.do`, params);
  },
  /**
   * 자동화 설정 > 태스크, 잡, 트리거 그룹 (공통) 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   */
  getAmsGrpList(params) {
    return axios.post(`${baseUrl}/settings/ams/common/get-ams-grp-list.do`, params);
  },
  /**
   * 자동화 설정 > 태스크, 잡, 트리거 그룹 트리(공통) 데이터 조회
   * @author jeee12
   * @param  {[type]} params [description]
   */
  getAmsGrpTreeData(params) {
    return axios.post(`${baseUrl}/settings/ams/common/get-ams-grp-tree-data.do`, params);
  },
  /**
   * 자동화 설정 > 태스크, 잡, 트리거 그룹 트리(공통) 데이터 추가, 수정, 삭제
   * @author jeee12
   * @param  {[type]} params [description]
   */
  updateAmsGrpTreeData(params) {
    return axios.post(`${baseUrl}/settings/ams/common/update-ams-grp-tree-data.do`, params);
  },
  /**
   * 자동화 설정 > 잡 설정 > 잡 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   */
  getJobList(params) {
    return axios.post(`${baseUrl}/settings/ams/job/get-job-list.do`, params);
  },
  /**
   * 자동화 설정 > 잡 설정 > 잡 추가 또는 수정
   * @author jeee12
   * @param  {[type]} params [description]
   */
  insertJob(params) {
    return axios.post(`${baseUrl}/settings/ams/job/insert-job.do`, params);
  },
  /**
   * 자동화 설정 > 잡 설정 > 잡 목록 삭제
   * @author jeee12
   * @param  {[type]} params [description]
   */
  deleteJobList(params) {
    return axios.post(`${baseUrl}/settings/ams/job/delete-job-list.do`, params);
  },
  /**
   * 자동화 설정 > 잡 설정 > 선택한 잡에 속한 잡 태스크 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   */
  getJobTaskList(params) {
    return axios.post(`${baseUrl}/settings/ams/job/get-job-task-list.do`, params);
  },
  /**
   * 자동화 설정 > 잡 설정 > 선택한 잡에 속한 플랫폼 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   */
  getJobNodetypeList(params) {
    return axios.post(`${baseUrl}/settings/ams/job/get-job-nodetype-list.do`, params);
  },
  /**
   * 자동화 설정 > 잡 설정 > 선택한 잡에 속한 잡 태스크 목록 삭제
   * @author jeee12
   * @param  {[type]} params [description]
   */
  deleteJobTaskList(params) {
    return axios.post(`${baseUrl}/settings/ams/job/delete-job-task-list.do`, params);
  },
  /**
   * 자동화 설정 > 잡 설정 > 선택한 잡에 속한 플랫폼 목록 삭제
   * @author jeee12
   * @param  {[type]} params [description]
   */
  deleteJobNodetypeList(params) {
    return axios.post(`${baseUrl}/settings/ams/job/delete-job-nodetype-list.do`, params);
  },
  /**
   * 자동화 설정 > 잡 설정 > 선택한 잡에 속한 플랫폼 정보와 설정할 태스크, 변수 정보 조회
   * @author jeee12
   * @param  {[type]} params [description]
   */
  getJobTaskSettingInfo(params) {
    return axios.post(`${baseUrl}/settings/ams/job/get-job-task-setting-info.do`, params);
  },
  /**
   * 자동화 설정 > 잡 설정 > 선택한 잡에 속한 태스크와 태스크 변수 추가 또는 수정
   * @author jeee12
   * @param  {[type]} params [description]
   */
  insertJobTaskVariable(params) {
    return axios.post(`${baseUrl}/settings/ams/job/insert-job-task-variable.do`, params);
  },
  /**
  * 자동화 설정 > 잡 설정 > 잡 플랫폼 중복 체크
  * @author jeee12
  * @param  {[type]} params [description]
  */
  checkJobNodetypeValidation(params) {
    return axios.post(`${baseUrl}/settings/ams/job/check-job-nodetype-validation.do`, params);
  },
  /**
  * 자동화 설정 > 잡 설정 > 잡 플랫폼 추가 또는 수정
  * @author jeee12
  * @param  {[type]} params [description]
  */
  insertJobNodetype(params) {
    return axios.post(`${baseUrl}/settings/ams/job/insert-job-nodetype.do`, params);
  },
  /**
  * 자동화 설정 > 잡 설정 > 잡 플랫폼 추가 또는 수정
  * @author jeee12
  * @param  {[type]} params [description]
  */
  getTriggerList(params) {
    return axios.post(`${baseUrl}/settings/ams/trigger/get-trigger-list.do`, params);
  },
  /**
  * 자동화 설정 > 잡 설정 > 트리거 추가 또는 수정
  * @author jeee12
  * @param  {[type]} params [description]
  */
  insertTrigger(params) {
    return axios.post(`${baseUrl}/settings/ams/trigger/insert-trigger.do`, params);
  },
  /**
  * 자동화 설정 > 잡 설정 > 트리거 목록 삭제
  * @author jeee12
  * @param  {[type]} params [description]
  */
  deleteTriggerList(params) {
    return axios.post(`${baseUrl}/settings/ams/trigger/delete-trigger-list.do`, params);
  },
  /**
  * 자동화 설정 > 트리거 설정 > 선택한 트리거에 속한 잡 목록 조회
  * @author jeee12
  * @param  {[type]} params [description]
  */
  getTrgJobList(params) {
    return axios.post(`${baseUrl}/settings/ams/trigger/get-trg-job-list.do`, params);
  },
  /**
  * 자동화 설정 > 잡 설정 > 트리거 추가 또는 수정
  * @author jeee12
  * @param  {[type]} params [description]
  */
  insertTrgJob(params) {
    return axios.post(`${baseUrl}/settings/ams/trigger/insert-trg-job.do`, params);
  },
  /**
  * 자동화 설정 > 잡 설정 > 트리거 목록 삭제
  * @author jeee12
  * @param  {[type]} params [description]
  */
  deleteTrgJobList(params) {
    return axios.post(`${baseUrl}/settings/ams/trigger/delete-trg-job-list.do`, params);
  },
  /**
  * 자동화 설정 > 트리거 설정 > 전체 노드 목록 조회
  * @author jeee12
  * @param  {[type]} params [description]
  */
  getNodeList(params) {
    return axios.post(`${baseUrl}/settings/ams/trigger/get-node-list.do`, params);
  },
  /**
  * 자동화 설정 > 트리거 설정 > 선택한 트리거의 잡에 해당하는 노드 목록 수정
  * @author jeee12
  * @param  {[type]} params [description]
  */
  updateTrgNodeList(params) {
    return axios.post(`${baseUrl}/settings/ams/trigger/update-trg-node-list.do`, params);
  },
  /**
  * 자동화 설정 > 트리거 설정 > 선택한 트리거-잡의 노드에 따른 태스크 변수 값 목록 조회
  * @author jeee12
  * @param  {[type]} params [description]
  */
  getNodeVariableList(params) {
    return axios.post(`${baseUrl}/settings/ams/trigger/get-node-variable-list.do`, params);
  },
  /**
  * 자동화 설정 > 트리거 설정 > 선택한 트리거-잡의 노드에 따른 태스크 변수 값 추가 또는 수정
  * @author jeee12
  * @param  {[type]} params [description]
  */
  updateTrgNodeVarValues(params) {
    return axios.post(`${baseUrl}/settings/ams/trigger/update-trg-node-var-values.do`, params);
  },
  /**
  * 자동화 설정 > 잡 설정 > 잡 이름 중복 체크
  * @author jeee12
  * @param  {[type]} params [description]
  */
  checkJobNameValidation(params) {
    return axios.post(`${baseUrl}/settings/ams/job/check-job-name-validation.do`, params);
  },
  /**
  * 자동화 설정 > 잡 설정 > 선택한 잡에 대한 복사
  * @author jeee12
  * @param  {[type]} params [description]
  */
  copyJobList(params) {
    return axios.post(`${baseUrl}/settings/ams/job/copy-job-list.do`, params);
  },
  /**
  * 자동화 설정 > 트리거 설정 > 트리거 이름 중복 체크
  * @author jeee12
  * @param  {[type]} params [description]
  */
  checkTriggerNameValidation(params) {
    return axios.post(`${baseUrl}/settings/ams/trigger/check-trigger-name-validation.do`, params);
  },
  /**
  * 자동화 설정 > 트리거 설정 > 선택한 트리거에 대한 복사
  * @author jeee12
  * @param  {[type]} params [description]
  */
  copyTriggerList(params) {
    return axios.post(`${baseUrl}/settings/ams/trigger/copy-trigger-list.do`, params);
  },
  /**
  * 자동화 설정 > 태스크 설정 > 선택한 태스크에 대한 복사
  * @author jeee12
  * @param  {[type]} params [description]
  */
  copyTaskList(params) {
    return axios.post(`${baseUrl}/settings/ams/task/copy-task-list.do`, params);
  },
  /**
   * 자동화 설정 > 트리거 설정 > 선택한 트리거의 변수 값 엑셀 입력을 위한 엑셀 템플릿 출력
   * @author jeee12
   * @param  {[type]} params [description]
   */
  exportTrgNodeVarValueList(params) {
    return axios.post(`${baseUrl}/settings/ams/trigger/export-trg-node-var-value-list.do`, params);
  },
  /**
  * 자동화 설정 > 트리거 설정 > 선택한 트리거의 변수 값 엑셀 입력
  * @author jeee12
  * @param  {[type]} params [description]
  */
  importTrgNodeVarValueByExcel(params) {
    return axios.post(`${baseUrl}/settings/ams/trigger/import-trg-node-var-value-by-excel.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/server/ams-settings.js